var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-wrapper"},[_c('router-view',{attrs:{"name":"nav","instance":_vm.instance,"instance-name":_vm.instanceName}}),_c('router-view',{attrs:{"name":"body","instance":_vm.instance,"instance-name":_vm.instanceName}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }